import React, { useState, useEffect } from 'react'
import '../Styles/Dropdown.css'
export default function DropDown(props) {
    const [options,setOpt] = useState([])
    const [values, setVal] = useState([])
    useEffect(() => {
        if (props.options) {
            console.log(props.options)
            setOpt(props.options)
        } else { setOpt([]) }
    }, [props.options])
    useEffect(() => {
        if (props.values) {
            console.log(props.values)
            setVal(props.values)
            let opt=options.filter(value => !values.includes(value))
            console.log(opt)
            setOpt(opt)
        } else { setVal([]) }
    }, [props.values])
    const add = async (ed) => {
        setVal([...values,ed.e])
        let opts=await options.filter(opt => opt.user_id != ed.e.user_id );
        setOpt(opts)
    }
    const remove = async (e) => {
        setOpt([...options,e])
        let vals=await values.filter(val => val.user_id != e.user_id );
        setVal(vals)
    }
    const filter = async(val) => {
        if(val.length==0){
            setOpt(props.options)
            return;
        }
        let opts=await options.filter(opt => opt.user_id.toLowerCase().match(val.toLowerCase()) || opt.name.toLowerCase().match(val.toLowerCase()));
        setOpt(opts)
    }
    const [hover,setHover]=useState(true)
    return (
        <div
            onMouseLeave={() => {
                setHover(false)
                props.parentCallback(values);
                // document.getElementsByClassName('myDropdownmenu')[0].classList.remove('ShowmyDropdownmenu')
            }}
            onMouseEnter={()=>setHover(true)}
            className='myDropdownBap'><br/>
            <div style={{transform:hover?'scale(1)':'scale(0)',height:hover?'150px':'0px'}} className='myprojmemlist'>
                {
                    options.map(e => {
                        return <div onClick={(ed) => add({ e: e })}>{e.user_id + ' ' + e.name}<i class="fas fa-check"></i></div>
                    })
                }
            </div>
            <div style={{justifyContent:'center',margin:0,backgroundColor:'white',color:'black',transform:!hover?'scale(1)':'scale(0)',height:!hover?'35px':'0px'}} >Select</div>
            <input style={{transform:hover?'scale(1)':'scale(0)',height:hover?'45px':'0px'}}  placeholder='Search Here...' onChange={(e) => filter(e.target.value)} type="text" id='spminput' />
            <div className='spc'>
                Selected members : <br/>
                {values.map(e => {
                    return <div>{e.user_id + ' ' + e.name}{<i onClick={()=>remove(e)} class="fas fa-times"></i>}</div>
                })}
            </div>
            {/* <center className='myDropdownmenu'>
            {options.map(itm=>{
               return <div className='myDropdownSingle'><input type='checkbox' 
               onChange={(e)=>!e.target.checked?setVal(values.filter(item => item.id != e.target.value)):setVal([...values, itm])} id={itm.id} value={itm.id}/>&ensp;
               <label for={itm.id}>{itm.name}</label><br/>
               </div>
            })}
            </center>
            <div id='dropdownupdate'>{values.map(e=>{
                return <div onClick={()=>{
                    setVal(values.filter(item => item.id != e.id));
                    document.getElementById(e.id).checked=false
                }}  className='myDropdowncircle'>{e.name}</div>
            })}<br/><div style={{cursor:'pointer'}}
            onMouseOver={()=>document.getElementsByClassName('myDropdownmenu')[0].classList.add('ShowmyDropdownmenu')} 
            > Select Project Members</div></div> */}
        </div>
    )
}
